import { Button, Col, Input, Modal, QRCode, Row, Typography } from "antd";
import "./deleteRoleModal.scss";
import React, { useEffect, useState } from "react";
import Icon from "../icon/icon";
import { HandleErrors } from "../../utils/handleErrors";
import { userDisableTotpCodeService } from "../../services/user.service";
import { toast } from "react-toastify";
import { GetRoleRes } from "../../interfaces/role.interface";
import { deleteRoleService } from "../../services/role.service";

interface Props {
  show: boolean;
  onClose: () => void;
  role: GetRoleRes
}

export const DeleteRoleModal: React.FC<Props> = (props) => {
  const [show, setShow] = useState(false);

  const [loading, setLoading] = useState(false);


  useEffect(() => {
    setShow(props.show);
  }, [props.show]);

  const submit = async () => {
    try {
      setLoading(true);
      const res = await deleteRoleService({
        id: props.role.id
      });
      setLoading(false);
      toast.success("نقش با موفقیت حدف شد");
      setShow(false);
      props.onClose();
    } catch (error) {
      HandleErrors(error);
      setLoading(false);
    }
  };

  return (
    <div className="DeleteRoleModal">
      <Modal
        destroyOnClose={true}
        title={"حدف نقش"}
        onCancel={() => {
          setShow(false);
          props.onClose();
        }}
        open={show}
        footer={null}
        width={550}
      >
        <div className="DeleteRoleModalContent">
          <Row justify={"center"}>
            <Col>
              <Icon src="/assets/icons/err-notif.svg" />
            </Col>
          </Row>
          <Row justify={"center"}>
            <Typography.Text className="title">
              آیا از حدف نقش {props.role.name} مطمئن هستید؟
            </Typography.Text>
          </Row>
          
          <Row
            justify={"space-between"}
            align={"middle"}
            style={{
              marginTop: 20,
            }}
          >
            <Col xs={11}>
              <Button onClick={submit} loading={loading} block className="btn">
                حذف
              </Button>
            </Col>
            <Col xs={11}>
              <Button
                onClick={() => {
                  props.onClose();
                  setShow(false);
                }}
                block
                type="primary"
                className="btn"
              >
                انصراف
              </Button>
            </Col>
          </Row>
        </div>
      </Modal>
    </div>
  );
};
